// TODO Even with hooks this component is big and hard to follow, should be refactored if possible

import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import FacetTextInput from './facet_text_input';

const { $ } = window;

const FacetTextInputs = ({
  isInUse,
  getParam,
  changeListener,
  removeChangeListener,
  isParamActive,
  setParam,
  withSelfUpdate
}) => {
  const initialInputs = {
    kw_and: {
      placeholder: 'With all of the following words'
    },
    kw_phrase: {
      placeholder: 'With the exact phrase'
    },
    kw_or: {
      placeholder: 'With one of the following words'
    },
    kw_not: {
      placeholder: 'Without the words'
    }
  };

  const delay = 500;
  const changeTimeout = useRef();

  const isParamDisabled = (param, inputs) => {
    if (param === 'kw_not') {
      return (
        inputs.kw_and.value.length === 0 &&
        inputs.kw_phrase.value.length === 0 &&
        inputs.kw_or.value.length === 0
      );
    }
    return false;
  };

  const setInputsDisabled = (inputs = initialInputs) => {
    Object.keys(inputs).forEach((param) => {
      inputs[param].disabled = isParamDisabled(param, inputs);
    });

    return inputs;
  };

  const paramValue = (currentParam) => {
    let param;
    if (currentParam === 'kw_and' && !isInUse()) {
      param = 'keywords';
    } else {
      param = currentParam;
    }

    return getParam(param) || '';
  };

  const setInputValues = () => {
    Object.keys(initialInputs).forEach((param) => {
      initialInputs[param].value = paramValue(param);
    });

    return initialInputs;
  };

  const getState = () => {
    return {
      inputs: setInputsDisabled(setInputValues())
    };
  };

  const [state, setState] = useState(getState());

  const onChange = () => {
    if (isInUse()) return;

    setState(getState());
  };

  useEffect(() => {
    if (withSelfUpdate) {
      onChange();
    }
  }, [isInUse]);

  useEffect(() => {
    if (changeListener) {
      changeListener(onChange);
    }

    return () => {
      if (removeChangeListener) {
        removeChangeListener(onChange);
      }
    };
  }, []);

  const handleTextChanged = (param, text) => {
    // eslint-disable-next-line no-useless-escape
    const escapedText = text.replace(/[-%,|\(\)]/g, '');
    const stateInputs = $.extend({}, state.inputs);
    stateInputs[param].value = escapedText;
    setInputsDisabled(stateInputs);
    setState({ inputs: stateInputs });

    // special logic to mirror keywords input into kw_and
    if (
      param !== 'kw_and' &&
      stateInputs.kw_and.value.length !== 0 &&
      !isParamActive('kw_and')
    ) {
      setParam('kw_and', stateInputs.kw_and.value);
    }

    // special disabled behavior for kw_not
    if (stateInputs.kw_not.disabled) {
      setParam('kw_not', '');
    }

    clearTimeout(changeTimeout.current);
    // eslint-disable-next-line no-return-assign
    changeTimeout.current = setTimeout(() => {
      setParam(param, escapedText.trim());
      // Clear out regular search if user clears out advanced search
      if (isInUse()) return;
      setParam('keywords', '');
    }, delay);
  };

  const itemsComponents = () => {
    const components = [];

    Object.keys(state.inputs).forEach((param) => {
      const input = state.inputs[param];
      components.push(
        <FacetTextInput
          key={param}
          param={param}
          value={input.value}
          placeholder={input.placeholder}
          disabled={input.disabled}
          handleTextChanged={handleTextChanged}
        />
      );
    });

    return components;
  };

  return <div>{itemsComponents()}</div>;
};

FacetTextInputs.propTypes = {
  isInUse: PropTypes.func,
  getParam: PropTypes.func,
  changeListener: PropTypes.func,
  removeChangeListener: PropTypes.func,
  isParamActive: PropTypes.func,
  setParam: PropTypes.func,
  withSelfUpdate: PropTypes.bool
};

export default FacetTextInputs;
